import { createTheme } from "@mui/material/styles";

// "Canopy" design system — friendly, legible, soft greens.
// Tokens mirror the approved design canvas (Shelby Estates UI Refresh).
export const canopy = {
  green: "#3e7a52",
  greenDark: "#2d5c3c",
  soft: "#e7f0e6",
  ink: "#253328",
  inkSoft: "#4c6152",
  muted: "#6b7c70",
  faint: "#93a397",
  border: "#e3e9e2",
  borderInput: "#d8e1d8",
  hairline: "#eef2ed",
  surface: "#f2f6f1",
  background: "#fbfcfa",
  danger: "#b3564d",
  dangerSoft: "#f6ecea",
  warn: "#8a5a2b",
  warnSoft: "#fdf3e2",
};

const fontStack = [
  '"Nunito Sans"',
  "system-ui",
  "-apple-system",
  '"Segoe UI"',
  "sans-serif",
].join(", ");

const theme = createTheme({
  palette: {
    primary: { main: canopy.green, dark: canopy.greenDark, contrastText: "#ffffff" },
    secondary: { main: canopy.inkSoft, contrastText: "#ffffff" },
    error: { main: canopy.danger },
    warning: { main: canopy.warn },
    info: { main: canopy.inkSoft },
    success: { main: canopy.green },
    divider: canopy.border,
    background: { default: canopy.background, paper: "#ffffff" },
    text: { primary: canopy.ink, secondary: canopy.muted },
  },
  typography: {
    fontFamily: fontStack,
    h4: { fontWeight: 800 },
    h5: { fontWeight: 800 },
    h6: { fontWeight: 800 },
    subtitle1: { fontWeight: 700 },
    subtitle2: { fontWeight: 700 },
    button: { fontWeight: 700, textTransform: "none" },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          fontSize: "0.95rem",
          paddingLeft: 22,
          paddingRight: 22,
          boxShadow: "none",
          "&:hover": { boxShadow: "none" },
        },
        sizeLarge: { minHeight: 52, fontSize: "1.05rem" },
        outlined: { borderWidth: 1.5, "&:hover": { borderWidth: 1.5 } },
      },
    },
    MuiPaper: {
      styleOverrides: {
        rounded: { borderRadius: 20 },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 20,
          border: `1px solid ${canopy.border}`,
          boxShadow: "0 2px 8px rgba(37, 51, 40, 0.05)",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          backgroundColor: "#ffffff",
          "& fieldset": { borderColor: canopy.borderInput, borderWidth: 1.5 },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontWeight: 800, borderRadius: 999 },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#ffffff",
          color: canopy.ink,
          boxShadow: "none",
          borderBottom: `1px solid ${canopy.border}`,
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: { borderRadius: 20 },
      },
    },
  },
});

export default theme;
